import React, { FC } from "react";
import { TCustomHtmlComponentProps } from "./types/CustomHtmlComponent.type";
import { CustomHtmlComponentModel } from "./models/CustomHtmlComponentModel.model";

const CustomHtmlComponent: FC<TCustomHtmlComponentProps> = (props) => {
  const model = new CustomHtmlComponentModel(props);

  return (
    <section dangerouslySetInnerHTML={{ __html: model.getInnerHtml.value as string }} />
  );
};

export default CustomHtmlComponent;
